webpackJsonp([9],{

/***/ 105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("relation_title")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("relation_subtitle")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid list-style"
  }, _vm._l((_vm.list), function(news) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "30px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-4",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": news.image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-8 info-style"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('a', {
      staticStyle: {
        "font-size": "18px",
        "color": "#4A4A4A!important",
        "text-decoration": "none"
      },
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.nls(news.title)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 0 10px 0",
        "font-size": "16px",
        "color": "#9B9B9B"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.nls(news.brief)) + "   [ " + _vm._s(news.date) + " ]\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "font-size": "16px"
      }
    }, [_c('a', {
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t("relation_more")) + "\n                        ")])])])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(69);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("d6479c66", content, true);

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/public_relation_bg_img_a.jpg?b72360527888dca29d5c9b1df8c6cf34";

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(35);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});



/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 59:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    data: function () {
        return {
            list: window.pubData.news
        };
    },
    methods: {
        nls: function (val) {
            return val[this.$i18n.locale];
        }
    },
    mounted: function () {
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_public_relation,
            zh_HK: this.$i18n.messages.zh_HK.page_title_public_relation,
            zh_CN: this.$i18n.messages.zh_CN.page_title_public_relation
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}body:after{background-image:url(" + __webpack_require__(14) + ")}a:active,a:hover,a:link,a:visited{color:#d3a571!important}.info-style{padding:20px 0 10px}@media (min-width:768px){.info-style{padding:0 0 0 30px}}.list-style{margin:0 20px 80px;padding:0 30px 20px;background-color:#fff}@media (min-width:768px){.list-style{margin:0 20px 80px;padding:0 30px 30px;background-color:#fff}}", ""]);

// exports


/***/ })

},[168]);


// WEBPACK FOOTER //
// js/public_relation.bundle.js?de25bf2345d5b2ed7228